module.exports = __webpack_public_path__ + "static/media/mc.f063b7b6.svg";